export default __webpack_public_path__ + "static/media/icon_lupe.9bcbe30d.svg";